<template>
  <div>
    <a-modal
      width="800px"
      v-model="isShow"
      centered
      :mask-closable="false"
      title="套餐详情"
    >
      <template slot="footer">
        <a-button class="ant-btn-primary" @click="closeModal">
          关闭
        </a-button>
      </template>

      <a-spin :spinning="spinning">
        <a-row>
          <a-col :span="12">
            <a-descriptions
              title="基本信息"
              :column="1"
              class="simiot-descriptions simiot-descriptions-max-6"
            >
              <a-descriptions-item label="套餐名称">
                {{ data.name }}
              </a-descriptions-item>

              <a-descriptions-item label="基础套餐名称">
                {{ data.base_product_name }}
              </a-descriptions-item>

              <a-descriptions-item label="运营商种类">
                {{ data.carrier_type }}
              </a-descriptions-item>

              <a-descriptions-item label="流量属性">
                {{ data.traffic_property }}
              </a-descriptions-item>

              <a-descriptions-item label="用户业务模式">
                {{ data.user_business_type }}
              </a-descriptions-item>

              <a-descriptions-item label="套餐周期">
                {{ data.service_cycle }}
              </a-descriptions-item>

              <a-descriptions-item label="套餐容量">
                {{ data.package_capacity }}
              </a-descriptions-item>

              <a-descriptions-item label="语音">
                {{ data.voice_capacity }}
              </a-descriptions-item>

              <a-descriptions-item label="套餐描述">
                {{ data.product_description }}
              </a-descriptions-item>

            </a-descriptions>

            <a-descriptions title="零售设置" :column="1" v-if="data.user_business_type_slug === 'custom_month'">
              <a-descriptions-item label="允许零售">
                {{ data.is_allow_retail }}
              </a-descriptions-item>

              <a-descriptions-item label="零售价设置者" v-if="data.is_allow_retail_slug">
                {{ data.retail_operator }}
              </a-descriptions-item>
            </a-descriptions>

            <a-descriptions title="其它设置" :column="1">
              <a-descriptions-item label="允许自订">
                {{ data.is_allow_self_subscribe }}
              </a-descriptions-item>

              <a-descriptions-item label="允许超池" v-if="data.user_business_type_slug === 'traffic_share'">
                {{ data.is_allow_exceed_pool }}
              </a-descriptions-item>
            </a-descriptions>

            <a-descriptions title="自定义功能" :column="1" v-if="isCustomDay">
              <a-descriptions-item label="是否限制订购周期数">
                {{ data.is_limit_subscribe_cycle }}
              </a-descriptions-item>

              <a-descriptions-item label="单卡可订购周期数(个)" v-if="data.is_limit_subscribe_cycle_slug">
                {{ data.limit_subscribe_cycle }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>

          <a-col :span="12">
            <a-descriptions title="价格设置" :column="favorablePriceColumnSize">
              <a-descriptions-item>
                周期数
              </a-descriptions-item>

              <a-descriptions-item>
                底价(元)
              </a-descriptions-item>

              <a-descriptions-item>
                客户价(元)
              </a-descriptions-item>

              <a-descriptions-item v-if="data.is_allow_retail_slug && data.retail_operator_slug === 'platform'">
                零售价(元)
              </a-descriptions-item>
            </a-descriptions>

            <a-descriptions
              :column="favorablePriceColumnSize"
              v-for="favorablePrice in data.agents_product_favorable_prices"
              :key="`favorable_price_${favorablePrice.cycles}`"
            >
              <a-descriptions-item>
                {{ favorablePrice.cycles }}
              </a-descriptions-item>

              <a-descriptions-item>
                {{ favorablePrice.floor_price }}
              </a-descriptions-item>

              <a-descriptions-item>
                {{ favorablePrice.distributor_price }}
              </a-descriptions-item>

              <a-descriptions-item v-if="data.is_allow_retail_slug && data.retail_operator_slug === 'platform'">
                {{ favorablePrice.retail_price }}
              </a-descriptions-item>
            </a-descriptions>

            <a-descriptions
              :column="3"
              v-if="!isCustomDay && !isMerchantSales"
            >
              <a-descriptions-item>
                超额计费单位
              </a-descriptions-item>

              <a-descriptions-item>
                底价(元)
              </a-descriptions-item>

              <a-descriptions-item>
                客户价(元)
              </a-descriptions-item>

              <a-descriptions-item>
                {{ data.excess_rate_quantity }}
              </a-descriptions-item>

              <a-descriptions-item>
                {{ data.excess_floor_price }}
              </a-descriptions-item>

              <a-descriptions-item>
                {{ data.excess_distributor_price }}
              </a-descriptions-item>
            </a-descriptions>

            <a-descriptions
              :column="2"
              v-if="this.userBusinessType === 'custom_month' || this.userBusinessType === 'traffic_share'"
            >
              <a-descriptions-item>
                停机保号底价(元)
              </a-descriptions-item>

              <a-descriptions-item>
                停机保号客户价(元)
              </a-descriptions-item>

              <a-descriptions-item>
                {{ data.stop_floor_price }}
              </a-descriptions-item>

              <a-descriptions-item>
                {{ data.stop_distributor_price }}
              </a-descriptions-item>
            </a-descriptions>

            <a-descriptions title="卡片设置" :column="3">
              <a-descriptions-item>
                卡片材质
              </a-descriptions-item>

              <a-descriptions-item>
                底价(元)
              </a-descriptions-item>

              <a-descriptions-item>
                客户价(元)
              </a-descriptions-item>

            </a-descriptions>

            <a-descriptions
              :column="3"
              v-for="agentsProductsCardType in data.agents_products_card_types"
              :key="`card_type_${agentsProductsCardType.id}`"
            >
              <a-descriptions-item>
                {{ agentsProductsCardType.card_type_name }}
              </a-descriptions-item>

              <a-descriptions-item>
                {{ agentsProductsCardType.floor_price | formatFloat }}
              </a-descriptions-item>

              <a-descriptions-item>
                {{ agentsProductsCardType.price | formatFloat }}
              </a-descriptions-item>
            </a-descriptions>
          </a-col>
        </a-row>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { findAgentsProduct } from '@/api/agents_product'

export default {
  name: 'ShowAgentsProduct',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: {},
      userBusinessType: '',
      favorablePriceColumnSize: 3,
      isCustomDay: false,
      isMerchantSales: false,
      isTrafficSharePackage: false,
      spinning: true
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.spinning = true
      findAgentsProduct(this.id).then((res) => {
        this.data = res.data
        this.userBusinessType = this.data.user_business_type_slug
        this.favorablePriceColumnSize = this.data.is_allow_retail_slug && this.data.retail_operator_slug === 'platform' ? 4 : 3
        if (this.userBusinessType === 'custom_day') {
          this.isCustomDay = true
        }

        if (this.userBusinessType === 'merchant_sales') {
          this.isMerchantSales = true
        }

        if (this.userBusinessType === 'traffic_share_package') {
          this.isTrafficSharePackage = true
        }

        this.spinning = false
      })
    },

    closeModal() {
      this.isShow = false
    }
  }
}
</script>
